<template>
  <div class="">
    <i class="icn icn-credit-card" v-if="type === 'credit-card'"></i>
    <img src="@/assets/icons/direct-debit.svg" width="40" height="40" v-if="type === 'direct-debit'" />
    <span v-if="type !== 'direct-debit' && type !== 'credit-card'">{{ type }}</span>
  </div>
</template>

<script>
export default {
  name: 'PaymentIcons',
  props: {
    type: String,
  },
};
</script>

<style lang="scss" scoped>
</style>